import { bindUrl, request } from "./request";

export function supplyOilAppoint(data) {
  return request({
    url: bindUrl("/svc-oil/zlb/client/appointment/addOil"),
    method: "POST",
    data
  });
}

export function getAppointHistory(params) {
  return request({
    url: bindUrl("/svc-oil/zlb/client/appointment/oilList"),
    method: "GET",
    params
  });
}

export function getAppointMap(params) {
  return request({
    url: bindUrl("/svc-oil/zlb/client/ship/track"),
    method: "GET",
    params
  });
}
